import Constant from '../../../const';
const axios = require('axios');

const getSurgicalSafetyChecklistData = async id => {
  const response = await axios.get(
    Constant.apiUrl.concat(`/document/surgical-safety-checklist/${id}`),
  );
  return response;
};

export default getSurgicalSafetyChecklistData;
